// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conversation-list-item-unread-badge-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  margin-left: 8px;
  margin-right: 0;
  flex: 1 0 auto;
}
.conversation-list-item {
  position: relative;
  box-sizing: border-box;
  padding: 7px 32px;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  line-height: 16px;
  background-color: rgba(0, 0, 0, 0);
  cursor: pointer;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
  min-height: 83.5px;
}

.conversation-list-item-icons {
  position: absolute;
  top: 8.5px;
  left: 5px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.conversation-list-item-icon {
  font-size: 14px;
  color: rgb(153, 153, 153);
}

.conversation-list-item.selected {
  background-color: rgba(0, 0, 0, 0.1);
}

.conversation-list-item.hovered {
  background-color: rgba(0, 0, 0, 0.05);
  cursor: pointer;
}

.conversation-list-item-avatars {
  position: relative;
  width: 42px;
  height: 42px;
}

.conversation-list-item-avatar-single {
  width: 42px;
  height: 42px;
  border-radius: 50%;
}

.conversation-list-item-avatar-first {
  position: absolute;
  width: 30.24px;
  height: 30.24px;
  margin: 0px;
  top: -0.84px;
  left: -0.84px;
  border-radius: 50%;
}

.conversation-list-item-avatar-second {
  position: absolute;
  width: 30.24px;
  height: 30.24px;
  margin: 0px;
  top: 12.6px;
  left: 12.6px;
  border-radius: 50%;
}

/* Placeholder avatars with initials */
.conversation-list-item-avatar-placeholder {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background-color: #000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  text-transform: uppercase;
}

.conversation-list-item-avatar-placeholder-first {
  position: absolute;
  width: 30.24px;
  height: 30.24px;
  margin: 0px;
  top: -0.84px;
  left: -0.84px;
  border-radius: 50%;
  background-color: #000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
}

.conversation-list-item-avatar-placeholder-second {
  position: absolute;
  width: 30.24px;
  height: 30.24px;
  margin: 0px;
  top: 12.6px;
  left: 12.6px;
  border-radius: 50%;
  background-color: #000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
}

.conversation-list-item-info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 10px;
  left: 80px;
  font-size: 16px;
  line-height: 22px;
  height: 22px;
  font-weight: normal;
  width: calc(100% - 100px);
}

.conversation-list-item-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: rgb(0, 0, 0);
  flex: 1 1 0%;
  font-weight: 500;
  min-width: 0; /* Allows the flex item to shrink and truncate text */
}

.conversation-list-item-invite-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  font-family: 'Roboto', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background-color: rgb(222, 72, 88);
  color: white;
  border-radius: 10px;
  white-space: nowrap;
  flex-shrink: 0;
}

.conversation-list-item-timestamp {
  font-size: 14px;
  color: rgb(153, 153, 153);
}

.conversation-list-item-message {
  position: absolute;
  top: 40px;
  left: 80px;
  height: 30px;
  color: rgb(153, 153, 153);
  font-size: 14px;
  font-weight: normal;
  width: calc(100% - 100px);
  overflow: hidden;
  overflow-wrap: anywhere;
  display: flex;
  align-items: center;
  flex-direction: row;
  line-height: 16px;
}

.conversation-list-item-message-text {
  flex: 1 1 0%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.conversation-list-item-message .fa-paperclip {
  margin-right: 6px;
  color: rgb(153, 153, 153);
}

.conversation-list-item-message-attachment {
  font-size: 11px;
  font-style: italic;
}

.conversation-list {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
  width: 100%;
}

.conversation-list-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  height: 200px; /* Provide some height for loading state */
}

.conversation-list-loading-text {
  color: #666;
  font-size: 14px;
  font-family: Roboto, sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/components/ConversationList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,YAAY,EAAE,qDAAqD;AACrE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,qBAAqB;EACrB,kCAAkC;EAClC,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa,EAAE,0CAA0C;AAC3D;;AAEA;EACE,WAAW;EACX,eAAe;EACf,+BAA+B;AACjC","sourcesContent":[".conversation-list-item-unread-badge-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  height: 100%;\n  margin-left: 8px;\n  margin-right: 0;\n  flex: 1 0 auto;\n}\n.conversation-list-item {\n  position: relative;\n  box-sizing: border-box;\n  padding: 7px 32px;\n  font-family: Roboto, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n  background-color: rgba(0, 0, 0, 0);\n  cursor: pointer;\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n  min-height: 83.5px;\n}\n\n.conversation-list-item-icons {\n  position: absolute;\n  top: 8.5px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.conversation-list-item-icon {\n  font-size: 14px;\n  color: rgb(153, 153, 153);\n}\n\n.conversation-list-item.selected {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.conversation-list-item.hovered {\n  background-color: rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n}\n\n.conversation-list-item-avatars {\n  position: relative;\n  width: 42px;\n  height: 42px;\n}\n\n.conversation-list-item-avatar-single {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n}\n\n.conversation-list-item-avatar-first {\n  position: absolute;\n  width: 30.24px;\n  height: 30.24px;\n  margin: 0px;\n  top: -0.84px;\n  left: -0.84px;\n  border-radius: 50%;\n}\n\n.conversation-list-item-avatar-second {\n  position: absolute;\n  width: 30.24px;\n  height: 30.24px;\n  margin: 0px;\n  top: 12.6px;\n  left: 12.6px;\n  border-radius: 50%;\n}\n\n/* Placeholder avatars with initials */\n.conversation-list-item-avatar-placeholder {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  background-color: #000;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.conversation-list-item-avatar-placeholder-first {\n  position: absolute;\n  width: 30.24px;\n  height: 30.24px;\n  margin: 0px;\n  top: -0.84px;\n  left: -0.84px;\n  border-radius: 50%;\n  background-color: #000;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.conversation-list-item-avatar-placeholder-second {\n  position: absolute;\n  width: 30.24px;\n  height: 30.24px;\n  margin: 0px;\n  top: 12.6px;\n  left: 12.6px;\n  border-radius: 50%;\n  background-color: #000;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.conversation-list-item-info {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  position: absolute;\n  top: 10px;\n  left: 80px;\n  font-size: 16px;\n  line-height: 22px;\n  height: 22px;\n  font-weight: normal;\n  width: calc(100% - 100px);\n}\n\n.conversation-list-item-title {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: rgb(0, 0, 0);\n  flex: 1 1 0%;\n  font-weight: 500;\n  min-width: 0; /* Allows the flex item to shrink and truncate text */\n}\n\n.conversation-list-item-invite-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  font-family: 'Roboto', sans-serif;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  background-color: rgb(222, 72, 88);\n  color: white;\n  border-radius: 10px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.conversation-list-item-timestamp {\n  font-size: 14px;\n  color: rgb(153, 153, 153);\n}\n\n.conversation-list-item-message {\n  position: absolute;\n  top: 40px;\n  left: 80px;\n  height: 30px;\n  color: rgb(153, 153, 153);\n  font-size: 14px;\n  font-weight: normal;\n  width: calc(100% - 100px);\n  overflow: hidden;\n  overflow-wrap: anywhere;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  line-height: 16px;\n}\n\n.conversation-list-item-message-text {\n  flex: 1 1 0%;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n}\n\n.conversation-list-item-message .fa-paperclip {\n  margin-right: 6px;\n  color: rgb(153, 153, 153);\n}\n\n.conversation-list-item-message-attachment {\n  font-size: 11px;\n  font-style: italic;\n}\n\n.conversation-list {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  height: 100%;\n  width: 100%;\n}\n\n.conversation-list-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 20px;\n  height: 200px; /* Provide some height for loading state */\n}\n\n.conversation-list-loading-text {\n  color: #666;\n  font-size: 14px;\n  font-family: Roboto, sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
